import React from 'react';
import { Star } from '@mui/icons-material';
import ProfileDescriptorLink from '@/components/common/ProfileDescriptorLink';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';

type ContentAssigneesProps = {
  assignees?: {
    alias?: string;
    displayName?: string;
    primary?: boolean;
    userId?: string;
  }[];
  className?: string;
  title?: string;
};

/**
 * @deprecated this should be replaced with composing the entity details
 * using the entity detail components, much like <OpportunityDetailsContent>
 */
function ContentAssignees({
  assignees,
  className,
  title,
}: ContentAssigneesProps) {
  const ownerOrgId = useOwnerOrgId();

  return (
    <div className={className}>
      {title && <h2 className="pb-3 text-base font-semibold">{title}</h2>}
      {assignees?.map(({ alias, displayName, userId, primary }) => (
        <div className="flex items-center" key={userId}>
          <ProfileDescriptorLink
            displayName={displayName || alias || ''}
            ownerOrgId={ownerOrgId}
            userId={userId || ''}
          />
          {primary && <Star className="ml-3 h-4 w-4 text-primary-main" />}
        </div>
      ))}
    </div>
  );
}

ContentAssignees.defaultProps = {
  assignees: [],
  className: '',
  title: null,
};

export default ContentAssignees;
